import React, { useState, useEffect, useRef } from "react";
import { Carousel } from "react-responsive-carousel";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Review.css";
import "../../index.css";

import { useTranslation } from "react-i18next";
import popupprevArrow from "../../assets/images/popupprevArrow.svg";
import popupnextArrow from "../../assets/images/popupnextArrow.svg";
import useWindowSize from "../../utils/useWindowSize";

const Review = ({ rview, newReviews, index, timeStamp }) => {
  dayjs.extend(relativeTime);
  const [showMore, setShowMore] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0); // Set initial index to the one passed in props
  const carouselRef = useRef(null);
  const { t } = useTranslation();
  const [timeago, setTimeago] = useState("");

  //image carousal starts
  const [OpenImages, setOpenImages] = useState(false);
  const [ImagesCurrentIndex, setImagesCurrentIndex] = useState(0);

  const ImageCarouselRef = useRef(null);

  const HandleImageClick = () => {
    setOpenImages(!OpenImages);
  };

  const goToNextImage = () => {
    const nextImagesIndex =
      ImagesCurrentIndex === rview.images.length - 1
        ? 0
        : ImagesCurrentIndex + 1;
    setImagesCurrentIndex(nextImagesIndex);
    ImageCarouselRef.current.moveTo(nextImagesIndex);
  };

  const goToPrevImage = () => {
    const prevImagesIndex =
      ImagesCurrentIndex === 0
        ? rview.images.length - 1
        : ImagesCurrentIndex - 1;
    setImagesCurrentIndex(prevImagesIndex);
    ImageCarouselRef.current.moveTo(prevImagesIndex);
  };

  //image carousal ends

  const renderStars = (customerRating, maxRating) => {
    let revisedCustomerRating;
    let wholeStars;
    let halfStar;
    let emptyStars;

    if (maxRating === 10) {
      revisedCustomerRating = customerRating / 2;
      wholeStars = Math.floor(revisedCustomerRating);
      halfStar = revisedCustomerRating % 1 >= 0.5 ? 1 : 0;
      emptyStars = Math.max(5 - (wholeStars + halfStar), 0) || 0;
    } else {
      wholeStars = Math.floor(customerRating);
      halfStar = customerRating % 1 >= 0.5 ? 1 : 0;
      emptyStars = Math.max(5 - (wholeStars + halfStar), 0) || 0;
    }

    return (
      <div className="star-rating">
        {[...Array(wholeStars)].map((_, Starindex) => (
          <span
            style={{ fontSize: "19px" }}
            key={Starindex}
            className="material-icons"
          >
            star
          </span>
        ))}
        {halfStar === 1 && (
          <span style={{ fontSize: "19px" }} className="material-icons">
            star_half
          </span>
        )}
        {[...Array(emptyStars)].map((_, index) => (
          <span
            key={index + wholeStars + 1}
            className="material-icons"
            style={{ fontSize: "19px" }}
          >
            star_border
          </span>
        ))}
      </div>
    );
  };

  const renderImagesWhenSmallImgClicked = (Images) => {
    return (
      <div className="containerForImagesCarousal">
        <img
          className="goPrevforImageCarousal"
          onClick={goToPrevImage}
          src={popupprevArrow}
        />

        <Carousel
          ref={ImageCarouselRef}
          showArrows={false}
          showIndicators={false}
          showStatus={false}
          showThumbs={false}
          selectedItem={ImagesCurrentIndex}
          onChange={(index) => setImagesCurrentIndex(index)} // Sync carousel changes
          transitionTime={10} // Transition duration in milliseconds
          className="ImagesCarousal"
        >
          {Images?.length > 0 &&
            Images.map((image) => {
              const originalImageUrl = image?.image_url;

              // Modify the URL to r  esize the image to desired dimensions
              const resizedImageUrl = originalImageUrl?.match(/w\d+-h\d+/)
                ? originalImageUrl.replace(/w\d+-h\d+/, "w600-h600") // Resize to 500x500px
                : originalImageUrl;
              return (
                <div className="Imagesclickedonbottomdivwhenpopupisnotopen">
                  <span
                    className="material-symbols-outlined closeSign"
                    style={{ color: "white" }}
                    onClick={HandleImageClick}
                  >
                    close
                  </span>
                  <img src={resizedImageUrl || originalImageUrl} />;
                </div>
              );
            })}
        </Carousel>
        <img
          className="goNextforImageCarousal"
          onClick={goToNextImage}
          src={popupnextArrow}
        />
      </div>
    );
  };

  const renderImages = (images) => {
    // console.log("printing images inside renderImages component", images);

    if (!images || images?.length === 0) {
      return null; // Return null instead of an empty div
    } else {
      return (
        <div className="imagesContainerInPopupDiv">
          <b>
            <p>Photos Shared {`(${images?.length})`}</p>
          </b>

          <div
            className={
              images.length === 1 ? "imagesDivwithOneImage" : "imagesDiv"
            }
          >
            {images?.map((img, index) => {
              const originalImageUrl = img?.image_url;

              // Modify the URL to resize the image to desired dimensions
              const resizedImageUrl = originalImageUrl?.match(/w\d+-h\d+/)
                ? originalImageUrl.replace(/w\d+-h\d+/, "w500-h500") // Resize to 500x500px
                : originalImageUrl;

              return (
                <img
                  key={`image-${index}`}
                  id={images.length === 1 ? "toSetSingleImageinPopupDiv" : ""}
                  style={{
                    objectFit: "cover",
                  }}
                  src={resizedImageUrl || originalImageUrl} // Fallback to original URL if resizing fails
                  alt="Img"
                />
              );
            })}
          </div>
        </div>
      );
    }
  };

  //function for rendering vendor logos

  const renderLogos = (source) => {
    if (source?.title === "Google") {
      return "https://ik.imagekit.io/ArjunHotelzify/Google%20Logo.png?updatedAt=1734425867729";
    }

    if (source?.title === "Tripadvisor") {
      return "https://ik.imagekit.io/ArjunHotelzify/Tripadvisor.png?updatedAt=1734426637871";
    }

    if (source?.title === "Trip.com") {
      return "https://ik.imagekit.io/ArjunHotelzify/Trip.com?updatedAt=1734426520344";
    } else {
      return source?.image;
    }
  };

  useEffect(() => {
    if (showMore || OpenImages) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [showMore, OpenImages]);

  let nextSlide = () => {
    setCurrentIndex((previndex) =>
      previndex === newReviews.length - 1 ? 0 : previndex + 1
    );
  };

  let prevSlide = () => {
    setCurrentIndex((previndex) =>
      previndex === 0 ? newReviews.length - 1 : previndex - 1
    );
  };

  //for swiping on small sceens
  const { width } = useWindowSize();

  const [touchStart, setTouchStart] = useState(null);
  const [touchMove, setTouchMove] = useState(null);
  const [isSwiping, setIsSwiping] = useState(false);

  const handleTouchStart = (e) => {
    if (width > 600) return;
    setTouchStart(e.touches[0].clientX);
    setIsSwiping(true);
  };

  const handleTouchMove = (e) => {
    if (!isSwiping || width > 600) return;
    // Record the movement of the finger
    setTouchMove(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchMove || width > 600) {
      setIsSwiping(false);
      return;
    }

    const distance = touchStart - touchMove;
    const swipeThreshold = 50; // Minimum swipe distance to trigger action

    if (distance > swipeThreshold && currentIndex < newReviews.length - 1) {
      // Swipe left
      setCurrentIndex(currentIndex + 1);
    } else if (distance < -swipeThreshold && currentIndex > 0) {
      // Swipe right
      setCurrentIndex(currentIndex - 1);
    }

    // Reset swipe state
    setIsSwiping(false);
    setTouchStart(null);
    setTouchMove(null);
  };

  return (
    <div className="review" id="review">
      <div
        className="reviewBody"
        onClick={() => {
          //below operation is to set the index of the popup div in line with what is being clicked
          if (rview?.review_text?.length > 122) {
            const filteredIndex = newReviews?.findIndex(
              (review) => review === rview
            );
            setCurrentIndex(filteredIndex);
            setShowMore(true);
          }
        }}
      >
        <div className="smallViewRatingAndImage">
          <div className="leftDivinsidebottomdiv">
            {rview?.author?.image && <img src={rview.author.image} alt="img" />}
            <p>
              <b>{rview?.author?.name || "Anonymous"}</b>
            </p>
          </div>

          <img
            style={
              rview?.source?.title === "Google"
                ? { width: "34px", height: "34px" }
                : rview?.source?.title === "Tripadvisor"
                ? { width: "45px", height: "45px" }
                : rview?.source?.title === "Trip.com"
                ? { width: "34px", height: "34px" }
                : {}
            }
            loading="lazy"
            src={renderLogos(rview?.source)}
            alt={rview?.source?.title}
          />
        </div>
        {showMore || rview?.review_text?.length < 122 ? (
          <div className="textOnSmallReviewDiv">
            <p>{rview?.review_text?.slice(0, 122)}...</p>
            {(showMore || rview?.review_text?.length > 122) && ( //I think I can remove this
              <p
                style={{
                  color: "#0078d4",
                  cursor: "pointer",
                  width: "fit-content",
                  marginTop: "5px",
                }}
                onClick={() => setShowMore(true)}
              >
                {/* {t("Read More")} */}
              </p>
            )}
          </div>
        ) : (
          <div className="textOnSmallReviewDiv">
            {rview?.review_text !== null && (
              <>
                <p>{rview?.review_text?.slice(0, 122)}...</p>
                <p
                  style={{
                    color: "#0078d4",
                    cursor: "pointer",
                    width: "fit-content",
                    marginTop: "5px",
                  }}
                  onClick={() => {
                    if (rview?.review_text?.length > 122) {
                      const filteredIndex = newReviews?.findIndex(
                        (review) => review === rview
                      );
                      setCurrentIndex(filteredIndex);
                      setShowMore(true);
                    }
                  }}
                >
                  {t("Read More")}
                </p>
              </>
            )}
          </div>
        )}

        <div className="bottomDiv">
          <div style={{ marginTop: "15px" }}>
            {rview?.rating?.value !== undefined &&
              renderStars(rview?.rating?.value, rview?.rating?.rating_max)}
            <p id="reviewTimeStampOuter">
              {timeStamp} {t(`on ${rview?.source?.title}`)}
            </p>
          </div>

          {rview?.images?.length > 0 && (
            <div className="imageCountDiv">
              {/* Show first two images if available */}
              <div className="imageContainer">
                {rview?.images?.slice(0, 2).map((img, index) => (
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                      HandleImageClick();
                    }}
                    style={{ cursor: "pointer" }}
                    key={index}
                    src={img?.image_url}
                    className={`image ${
                      index === 1 && rview?.images?.length > 1
                        ? "secondImage"
                        : ""
                    }`}
                  />
                ))}
              </div>

              {/* If there are more than 2 images, show the count */}
              {rview?.images?.length > 2 && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    HandleImageClick();
                  }}
                  style={{
                    cursor: "pointer",
                    marginLeft: rview?.images?.length <= 19 ? "-25px" : "-30px",
                  }}
                  className="imageCount"
                >{`+${rview?.images?.length - 2}`}</div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Carousal small images are clicked */}
      {OpenImages && renderImagesWhenSmallImgClicked(rview?.images)}

      {/* Popup and Carousel */}
      {showMore && (
        <div
          style={{
            width: "100%",
            height: "100%",
            zIndex: 9000,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "fixed",
            top: "0",
            left: "0",
          }}
          className="topDiv"
        >
          <span
            className="material-symbols-outlined closeSignforpopupsiv"
            style={{ color: "white", cursor: "pointer" }}
            onClick={() => setShowMore(false)}
          >
            close
          </span>{" "}
          <div className="slideContainer">
            <div
              className="slider"
              style={{
                transform: `translateX(-${currentIndex * 100}%)`,
                transition: isSwiping
                  ? "none"
                  : width < 600
                  ? "transform 0.3s ease-in-out"
                  : width >= 600
                  ? "transform 0.0s ease-in-out"
                  : "none",
              }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              {newReviews?.map((rv, index) => {
                const benchmarkDate = new Date(2024, 0, 1);
                const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
                const benchmarkDateIST = new Date(
                  benchmarkDate.getTime() + istOffset
                ); // Adjust to IST
                const defaultTimeStamp = benchmarkDateIST.toISOString();
                const propTimeStamp =
                  new Date(rv.timestamp) < benchmarkDate
                    ? dayjs(defaultTimeStamp).fromNow()
                    : dayjs(rv.timestamp).fromNow();
                return (
                  <div key={index} className="dummyImagesSlide">
                    {/* <img src={image} alt={`Slide ${index + 1}`} /> */}
                    <div className="headerLeft">
                      {rv?.author?.image && (
                        <img
                          src={rv?.author?.image}
                          alt="img"
                          title="google review"
                          referrerPolicy="no-referrer"
                          loading="lazy"
                        />
                      )}
                      {
                        <p>
                          <b>{rv?.author?.name || "Anonymous"}</b>
                        </p>
                      }
                    </div>
                    <div className="RatingDiv">
                      <div className="leftdivInsideRatingDiv">
                        {rv?.rating?.value !== undefined &&
                          renderStars(
                            rv?.rating?.value,
                            rv?.rating?.rating_max
                          )}
                        <p id="reviewTimeStampInner">
                          {propTimeStamp} {t(`on ${rv?.source?.title}`)}
                        </p>
                      </div>

                      <div className="RightdivInsideRatingDiv">
                        <img
                          style={{
                            backgroundColor: "white",
                            ...(rv?.source?.title === "Google"
                              ? { width: "31px", height: "32px" }
                              : rv?.source?.title === "Tripadvisor"
                              ? { width: "40px", height: "40px" }
                              : rv?.source?.title === "Trip.com"
                              ? { width: "34px", height: "34px" }
                              : {}),
                          }}
                          src={renderLogos(rv?.source)}
                        />
                        <p
                          className="sourceTitleinPopupdiv"
                          style={{
                            backgroundColor: "white",
                            ...(rv?.source?.title === "Google"
                              ? { fontSize: width <= 600 ? "15px" : "19px" }
                              : rv?.source?.title === "Tripadvisor"
                              ? { fontSize: width <= 600 ? "15px" : "19px" }
                              : rv?.source?.title === "Trip.com"
                              ? { fontSize: width <= 600 ? "15px" : "19px" }
                              : rv?.source?.title === "BedroomVillas.co.uk"
                              ? {
                                  fontSize: width <= 600 ? "12px" : "17px",
                                }
                              : { fontSize: width <= 600 ? "14px" : "17px" }),
                          }}
                        >
                          {rv?.source?.title}
                        </p>
                      </div>
                    </div>
                    <div className="textandImagesdivinpopupdiv">
                      {rv?.review_text?.length > 0 ? (
                        <p>{rv?.review_text}</p>
                      ) : null}
                      <div className="imagesInPopupDiv">
                        {rv?.images?.length > 0
                          ? renderImages(rv?.images)
                          : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <button className="prev reviewcompbuttons" onClick={prevSlide}>
              <img src={popupprevArrow} alt="Prev" />
            </button>
            <button className="next reviewcompbuttons" onClick={nextSlide}>
              <img src={popupnextArrow} alt="Next" />
            </button>
          </div>
          <div
            className="dotsContainer"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "1vw",
            }}
          >
            {newReviews.map((_, dotindex) => (
              <span
                key={index}
                className={`dot ${
                  dotindex === currentIndex ? "active-dot" : ""
                }`}
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                }}
                onClick={() => setCurrentIndex(dotindex)} // Update currentIndex on click
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

//added optional chaining at all possible fail points

export default Review;
